import { Table } from "react-bootstrap";
import All from "./All";

export default class CoordinateStatus{
    static All = All;
    static Table = Table;
}